<!-- @for (id of ids(); track $index) {
  <div>
    <div withLoadingSkeleton [isLoading]="!id">
      <ideal-cart-item-result-layout [itemId]="id" *ifInViewport />
    </div>
  </div>
} -->

<ideal-infinite-grid-layout [data]="ids()" [layoutStrategy]="1">
  <div *gridCell="let id">
    <!-- <div withLoadingSkeleton [isLoading]="!id"> -->
    <ideal-cart-item-result-layout [itemId]="id" />
    <!-- </div> -->
  </div>
</ideal-infinite-grid-layout>
